import React from 'react';
import PropTypes from 'prop-types';
import PfptLabelWithInfo from '../../PfptLabelWithInfo/PfptLabelWithInfo';

export default function BrowsingRoleName({ isDefault, name }) {
    return isDefault
        ? <PfptLabelWithInfo
            tooltip="The default browsing role is a system generated role.
            This role will always be the lowest priority and cannot be deleted."
            tooltipText=""
        >
            Default Browsing Role
        </PfptLabelWithInfo>
        : name;
}

BrowsingRoleName.propTypes = {
    isDefault: PropTypes.bool,
    name: PropTypes.string.isRequired,
};
